import { Project } from "interfaces";

import FilterSummary from "ui-components/Data-Filters/Filter-Summary";

import { projectIsImpactAnalysisBinary } from "flows/impact-analysis-binary/interfaces";

import {
  getYTags,
  getYConditions,
  getTreatmentConditions,
  getTreatmentControlTags,
} from "flows/impact-analysis-binary/utils";

const ContextSummary = ({ project }: { project: Project }) => {
  if (!projectIsImpactAnalysisBinary(project)) return null;

  const yDefinition = getYConditions(project);
  const [successTag, failureTag] = getYTags(project);
  const conditions = getTreatmentConditions(project);
  const [treatmentTag, controlTag] = getTreatmentControlTags(project);

  return (
    <div className="m-1">
      <div className="mb-2">
        <p className="underline">1. Outcome Definition</p>
        <p className="ml-2 pl-2">
          <span className="underline">{successTag}</span>: Rows which meet ALL
          the below conditions:
        </p>
        <ul className="list list-inside list-decimal pl-2 ml-4">
          {yDefinition.map((f, i) => (
            <li key={i} className="list-item">
              <FilterSummary filter={f} />
            </li>
          ))}
        </ul>
        <p className="ml-2 pl-2">
          All other rows are tagged{" "}
          <span className="underline">{failureTag}</span>.
        </p>
      </div>
      <p className="underline">2. Event Definition</p>
      <p className="ml-2 pl-2">
        <span className="underline">{treatmentTag}</span>: Rows which meet ALL
        the below conditions:
      </p>
      <ul className="list list-inside list-decimal pl-2 ml-4">
        {conditions.map((f, i) => (
          <li key={i} className="list-item">
            <FilterSummary filter={f} />
          </li>
        ))}
      </ul>
      <p className="ml-2 pl-2">
        All other rows are <span className="underline">{controlTag}</span>.
      </p>
    </div>
  );
};

export default ContextSummary;
